import { CAN_SIGNALS, resolveCanSignals } from '@trackizy/formatters';

// One literal t() call per signal so scripts/check-i18n.js can see every key.
export function canLabel(key, t) {
  switch (key) {
    case 'rpm': return t('telemetry.can.rpm', 'RPM');
    case 'coolantTemp': return t('telemetry.can.coolantTemp', 'Coolant');
    case 'throttle': return t('telemetry.can.throttle', 'Throttle');
    case 'engineLoad': return t('telemetry.can.engineLoad', 'Engine load');
    case 'obdSpeed': return t('telemetry.can.obdSpeed', 'OBD speed');
    case 'obdOdometer': return t('telemetry.can.obdOdometer', 'Vehicle odometer');
    case 'engineHours': return t('telemetry.can.engineHours', 'Engine hours');
    case 'fuelLevel': return t('telemetry.can.fuelLevel', 'Fuel level');
    case 'fuelUsed': return t('telemetry.can.fuelUsed', 'Fuel used');
    case 'doorOpen': return t('telemetry.can.doorOpen', 'Door');
    case 'dtcCount': return t('telemetry.can.dtcCount', 'Fault codes');
    case 'axleWeight1': return t('telemetry.can.axleWeight1', 'Axle 1');
    case 'axleWeight2': return t('telemetry.can.axleWeight2', 'Axle 2');
    case 'ignitionOnCount': return t('telemetry.can.ignitionOnCount', 'Ignition count');
    default: return key;
  }
}

const ALERTS = { coolantTemp: (v) => v >= 105, rpm: (v) => v >= 4000 };

/** Telemetry "Engine" cards for the CAN/OBD signals this device actually reports. */
export function buildCanCards(device, attributes, t, icons) {
  const resolved = resolveCanSignals(device || {}, attributes || {});
  const cards = [];
  for (const def of CAN_SIGNALS) {
    const { value } = resolved[def.key];
    if (value === null || value === undefined) continue;
    cards.push({
      key: `can_${def.key}`,
      icon: icons[def.icon],
      label: canLabel(def.key, t),
      value: def.kind === 'boolean' ? (value ? t('vehicleList.on') : t('vehicleList.off')) : Number(value).toFixed(def.decimals),
      unit: def.unit || null,
      alert: Boolean(ALERTS[def.key]?.(value)),
      show: true,
    });
  }
  return cards;
}
